import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import Button from '@mui/material/Button';
import 'ag-grid-enterprise';
import * as Flags from 'country-flag-icons/react/3x2'
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import { countryToAlpha2 } from 'country-to-iso';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import TerritoriesForm from "../territories/TerritoriesForm";
import { useMediaQuery, useTheme } from '@mui/material';


const CountryList = () => {
      const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState("")
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);
    const perPage = 10;
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const navigate = useNavigate();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const [columnDefs, setColumnDefs] = useState([
        { field: 'isoCode', enableRowGroup: true },
        { field: 'name', enableRowGroup: true, cellRenderer: IconComponent, headerName: 'Country' },
        { field: 'territory', enableRowGroup: true }
    ]);

    function IconComponent(props) {
        let code = countryToAlpha2(props.value);
        const Flag = Flags[code?.toUpperCase()];
        return <span style={{ display: "flex" }}>{code ? <Flag width={18} style={{ marginInline: "5px" }} /> : ""} <p>{props.value}</p></span>
    }

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            try {
                await OAuthService.deleteData(url, row.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                findCountries();
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };

    const onGridReady = useCallback((params) => {
        setGridApi(params?.api);
            var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
            columnToolPanel.expandColumnGroups();
    }, []);

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'Countries.xlsx',
            sheetName: 'Countries'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);
    useEffect(() => {
        if (gridApi) {
                findCountries();
        }
    }, [gridApi]);
    const findCountries = async () => {
        gridApi?.showLoadingOverlay();
        try {
            const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
            let countries = list.data?._embedded?.countries;
            countries = await Promise.all(countries?.map(async (country) => {
                const territoryURL = `${url}/${country.id}/territory`;
                try {
                    let territoryListResponse = await OAuthService.getList(territoryURL);
                    const territories = territoryListResponse?.data;
                    country.territory = territories?.displayName;
                    return country
                } catch (e) {
                    console.log("error ==> ", e);
                }

            }));
            const data = countries.filter((item) => item !== undefined)
            setRowData(data);
        } catch (error) {
            console.log(error.message);
            setError(error.message);
        } finally {
    gridApi?.hideOverlay();
  }

    }


    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }
const goToRoleEdit = useCallback(
  (data) => {
    if (data?.id !== undefined) {
      navigate("/editCountries/" + data.id);
    }
  },
  [navigate],
);
  const onRowDoubleClicked = (params) => {
    if (isMobile) return; 
    goToRoleEdit(params?.data);
  };

  const onRowClicked = (params) => {
    if (!isMobile) return; 
    goToRoleEdit(params?.data);
  };
   

    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="Country"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addCountry"
                pageName="Country List"
                error={error}
                deleteDisable={deleteDisable}
                successMsg={successMsg}
                snackState={snackState}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    frameworkComponents={{
                        iconComponent: IconComponent
                    }}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    onRowClicked={onRowClicked}
                    gridRef={gridRef}
                    paginationPageSize={perPage}
                    cacheBlockSize={perPage}
                    saveGridStateName={'countryList'}
                />
            </div>
        </>
    );
}

export default CountryList